import { render, staticRenderFns } from "./Asesor.vue?vue&type=template&id=5946225e&scoped=true&"
import script from "./Asesor.vue?vue&type=script&lang=js&"
export * from "./Asesor.vue?vue&type=script&lang=js&"
import style0 from "./Asesor.vue?vue&type=style&index=0&id=5946225e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946225e",
  null
  
)

export default component.exports